<template>
    <el-icon v-if="text" size="small" @click="copyText">
        <CopyDocument />
    </el-icon>
</template>

<script setup>
import { ElMessage } from "element-plus";

const props = defineProps({
    text: {
        type: String,
    },
});

const copyText = async () => {
    try {
        await navigator.clipboard.writeText(props.text || '');
        ElMessage.success("复制成功！");
    } catch (err) {
        console.error(err);
        ElMessage.error("复制失败，请手动复制。");
    }
};
</script>

<style scoped>
.el-icon {
    cursor: pointer;
    margin: 0 4px;
}
</style>
